import React from 'react';
import { AlertCircle } from 'react-feather';

/**
 * Renders the dynamic concessionaire charges grid (1–5 fields).
 *
 * Charges definitions come from `useTenantLookups.charges` —
 * `[{other_charge_id, display_name, charge_name}, ...]`.
 *
 * Values are written into the parent form state under the canonical
 * field names the backend expects: `tenant_charge1` through
 * `tenant_charge5`, in the same order the charges array arrives. The
 * AddTenant backend wrote charge1..5 by index, matching the legacy
 * TenancyInfo logic — we keep that wire contract.
 */
const ChargesFieldset = ({ charges = [], values = {}, errors = {}, onChange, disabled = false }) => {
    if (!charges.length) return null;
    return (
        <>
            {charges.map((charge, idx) => {
                const fieldName = `tenant_charge${idx + 1}`;
                const v = values[fieldName];
                return (
                    <label key={charge.other_charge_id || idx} className="v3-field">
                        <span className="v3-label">{charge.display_name}</span>
                        <input
                            className="v3-input"
                            type="number"
                            step="0.001"
                            value={v ?? ''}
                            onChange={(e) => onChange(fieldName, e.target.value)}
                            placeholder="0"
                            disabled={disabled}
                        />
                        {errors[fieldName] && (
                            <span className="v3-sadmin-field-err">
                                <AlertCircle size={12} /> {errors[fieldName]}
                            </span>
                        )}
                    </label>
                );
            })}
        </>
    );
};

export default ChargesFieldset;
